import { render, staticRenderFns } from "./StockSectorQuery.vue?vue&type=template&id=1453c878&scoped=true"
import script from "./StockSectorQuery.vue?vue&type=script&lang=js"
export * from "./StockSectorQuery.vue?vue&type=script&lang=js"
import style0 from "./StockSectorQuery.vue?vue&type=style&index=0&id=1453c878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1453c878",
  null
  
)

export default component.exports